import AppModal from "@/components/AppModal";
import AppTextField from "@/components/AppTextField";
import NationChooser from "@/components/NationChooser";
import AppLoadingButton from "@/components/mui/LoadingButton";
import RouteConstant from "@/constant/RouteConstant";
import { VerifyAction } from "@/constant/VerifyConstant";
import useToggle from "@/hook/useToggle";
import { getTaskId, onAppendForgotPwState, setTaskId, setTaskRuleParams, setToken } from "@/redux/slices/user";
import { dispatch } from "@/redux/store";
import { findPwExist, findPwReset } from "@/services/user/security";
import { Box, InputAdornment,IconButton } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { createSearchParams, useNavigate } from "react-router-dom";
import Security2FA from "../security/Security2FA";
import classes from "./components/css/index.module.less";
import {enqueueSnackbar} from "notistack";
import RpIcon from "@/components/RpIcon";
import Header from '@/components/Header/Header';
import PasswordInput from "@/components/PasswordInput";

function ForgotPw() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { forgotPwState } = useSelector(state => state.user);

  const [username, setUsername] = useState('');
  const [nationCode, setNationCode] = useState('');
  const [step, setStep] = useState(1);
  const [asMobile, setAsMobile] = useState(false);
  const [nationRecord, setNationRecord] = useState(null);

  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [sign, setSign] = useState('');
  const [loading, setLoading] = useState(false);
  const [passwordMatchError, setPasswordMatchError] = useState('');

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordConfirmVisible, setPasswordConfirmVisible] = useState(false);

  useEffect(() => {
    if (forgotPwState) {
      _updateState();
    }
  }, [forgotPwState]);

  const {
    toggle: show2FA,
    onToggle: onToggleShow2FA,
    setToggle: setToggleShow2FA,
  } = useToggle(false);

  const _updateState = () => {
    setUsername(forgotPwState.username);
    setNationCode(forgotPwState.nationCode);
    setAsMobile(!!forgotPwState.nationCode);
    setStep(forgotPwState.step ?? 1);
  }

  const onUsernameChange = function(e) {
    const username = e.target.value?.trim() || '';
    setUsername(username);
    const isMobile = !isNaN(username);
    setAsMobile(isMobile);
  };

  const onNationCodeChange = function(val) {
    setNationRecord(val);
    setNationCode(val.areaCode);
  };
  
  const _createStep = () => {
    if (step == 1) {
      return <AppTextField
        placeholder={t('username')}
        onChange={onUsernameChange}
        required
        value={username}
        fullWidth
        sx={{ mb: 4 }}
        InputProps={{
          startAdornment: asMobile ? (
            <InputAdornment position="start">
              <NationChooser
                record={nationRecord}
                onChange={onNationCodeChange}
              />
            </InputAdornment>
          ) : null,
        }}
      />
    }

    // TODO: 检查密码和密码确认匹配和密码可见不可见
    return <>
      {/*<AppTextField*/}
      {/*  placeholder={t('password')}*/}
      {/*  onChange={(e) => setPassword(e.target.value.trim())}*/}
      {/*  required*/}
      {/*  value={password}*/}
      {/*  type={passwordVisible ? 'text' : 'password'}*/}
      {/*  fullWidth*/}
      {/*  sx={{ mb: 4 }}*/}
      {/*  // clearable*/}
      {/*  // onClear={() => setPassword('')}*/}
      {/*  InputProps={{*/}
      {/*    endAdornment: (*/}
      {/*      <InputAdornment position="end">*/}
      {/*        <IconButton*/}
      {/*          onClick={() => setPasswordVisible(!passwordVisible)}*/}
      {/*        >*/}
      {/*          {passwordVisible ? (*/}
      {/*            <RpIcon icon="visible" size={22} />*/}
      {/*          ) : (*/}
      {/*            <RpIcon icon="invisible" size={22} />*/}
      {/*          )}*/}
      {/*        </IconButton>*/}
      {/*      </InputAdornment>*/}
      {/*    ),*/}
      {/*  }}*/}
      {/*/>*/}
      <PasswordInput
        placeholder={t('password')}
        onChange={(e) => setPassword(e.target.value.trim())}
        required
        value={password}
        type={passwordVisible ? 'text' : 'password'}
        fullWidth
      />
      <AppTextField
        placeholder={t('password_confirm')}
        onChange={(e) => setPasswordConfirm(e.target.value.trim())}
        required
        value={passwordConfirm}
        type={passwordConfirmVisible ? 'text' : 'password'}
        fullWidth
        sx={{ mb: 4, marginTop: 4 }}
        // clearable
        // onClear={() => setPasswordConfirm('')}
        error={!!passwordMatchError}
        helperText={passwordMatchError}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setPasswordConfirmVisible(!passwordConfirmVisible)}
              >
                {passwordConfirmVisible ? <RpIcon icon="eye_open" size={22} /> : <RpIcon icon="eye_close" size={22} />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </>
  }

  // 2FA 通过登录
  const _on2FAAllPass = async () => {
    onToggleShow2FA();
    setStep(2);
  }

  const _onClose2FAModal = () => {
    setTaskId(null);
    setTaskRuleParams(null);
    onToggleShow2FA();
  }

  const handleSubmit = useCallback(async (evt) => {
    evt.preventDefault();
    setPasswordMatchError('');
    setLoading(true);
    if (step === 2 && password !== passwordConfirm) {
      setPasswordMatchError(t('passwords_do_not_match'));
      setLoading(false);
      return;
    }
    if (step == 1) {
      try {
        const res = await findPwExist({
          username: username,
          nationCode: asMobile ? nationCode : null,
        });
        dispatch(onAppendForgotPwState({sign: res['sign']}));
  
        const taskData = res['data']?.['authRule'];
        setToken(res['tokenValue']);
        if (taskData) {
          setSign(res['sign']);
          // 2FA 流程
          setTaskRuleParams({
            taskId: taskData.taskId,
            action: VerifyAction.RESET_PW,
            task: taskData,
            sign: res['sign'],
          });
          setToggleShow2FA(true);
          // navigate({
          //   pathname: RouteConstant.SECURITY_2FA,
          //   search: createSearchParams({
          //     taskId: taskData.taskId,
          //   }).toString()
          // });
        }
      } finally {
        setLoading(false);
      }
    } else {
      try {
        await findPwReset({
          password: password,
          sign: sign,
        });
        // TODO: 提示找回密码成功
        enqueueSnackbar(t('password_reset_success'), { variant: 'success' })
        setToken(null);
        navigate(`${RouteConstant.LOGIN}?mode=login`);
      } finally {
        setLoading(false);
      }
    }
  }, [sign, username, password, passwordConfirm, asMobile, step])

  return (
    <Box sx={{width:"100%"}}>
      <Header/>
      <Box className={classes["authFlow-warp"]}>
        <div>{t('forgot_pw')}</div>
        <form autoComplete="off" onSubmit={handleSubmit}>
          {_createStep()}
          <AppLoadingButton
            fullWidth
            loading={loading}
            variant="contained"
            color="primary"
            size="large"
            type="submit"
          >
            {step == 1 ? t('next') : t('confirm')}
          </AppLoadingButton>
        </form>
      </Box>
      <AppModal open={show2FA} onClose={_onClose2FAModal}>
        <Security2FA callback={_on2FAAllPass} onClose={_onClose2FAModal}/>
      </AppModal>
    </Box>
  );
}

export default ForgotPw;
